<template>
    <div>
      <label class="vform-editor-label section">LABEL</label>
      <original-language-viewer
          v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
          :original-text="element.label.dix['Unknown']"
          class="mb-2"
      />
      <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
      <div class="dflex">
        <div class="col p-0">
        <textarea
            v-model="element.label.dix[$store.getters.getSelectedFormLanguage]"
            :title="element.label.dix['Unknown']"
            class="mb-1 form-text v-form-label form-text-dark"
            type="text"
        />
        </div>
      </div>
    </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import { vFormControls, placeholders } from "@/enum";
import OriginalLanguageViewer from "@/components/vForm/OriginalLanguageViewer.vue";
export default {
    name: "vFormFORM_SUMMARY",
  components: {OriginalLanguageViewer},
    mixins: [vFormElementMixin],
    props: {
        stepFormData: {type: Object, default: () => {return {}}}
    },
    data() {
        return {
            forceReRenderKey: 0,
            colorPickrId: null,
            vFormControls: vFormControls,
            placeholders: placeholders,
        };
    },
    beforeMount() {
        this.element.formElementType = vFormControls.FORM_SUMMARY;
    },
};
</script>
